<template>
  <dv-decoration-9 class="decoration-container" :color="color" :dur="dur">
    <template v-if="textContent">
      <span :style="style">{{ textContent }}</span>
    </template>
  </dv-decoration-9>
</template>
<script>
import { decoration9 } from '@jiaminghi/data-view'
import Vue from 'vue'
import Minin from './mixin'
Vue.use(decoration9)
export default {
  name: 'Decoration9',
  mixins: [Minin]
}
</script>
<style lang="less" scoped>
  .decoration-container{
    width: 100%;
    height: 100%;
  }
</style>